import { Container } from "reactstrap";
import CoursesList from "../features/courses/CoursesList";

const CoursesPage = () => {
    return (
        <Container>
            <CoursesList />
        </Container>
      );
}
 
export default CoursesPage;